export default __webpack_public_path__ + "assets/tuto1.jpg";